import { render, staticRenderFns } from "./password-verify.vue?vue&type=template&id=d2850960"
import script from "./password-verify.vue?vue&type=script&lang=js"
export * from "./password-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports